import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { CloseRounded } from '@mui/icons-material'
import { CancelButton, SaveButton, StrongPassword } from '../../../../../../shared/components/inputs'
import { changeUserPassword } from '../../../../../../../redux/actions/users'
import { useTranslation } from 'react-i18next'
import { StyledDialog } from '../../../../../../shared/styles/StyledDialog'

type UpdatePassword = {
  password: string
  confirmPassword: string
  isCorrect: boolean
}

type UserChangePasswordProps = {
  user_id: number
  open: boolean
  handleChangeOpen: (state: boolean) => void
}

// Export function that return 2 values
export function StateChangePasswordModal(): [boolean, (state: boolean) => void] {
  const [state, setState] = useState<boolean>(false)
  const changeState = (state: boolean) => {
    setState(state)
  }

  return [state, changeState]
}

function UserChangePassword({ user_id, open, handleChangeOpen }: UserChangePasswordProps) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const [updatePassword, setUpdatePassword] = useState<UpdatePassword>({
    password: '',
    confirmPassword: '',
    isCorrect: false
  })

  const handleInputChange = (inputName: string, value: string, isCorrect: boolean) => {
    setUpdatePassword({ ...updatePassword, [inputName]: value, isCorrect })
  }

  const handleSubmit = () => {
    if (updatePassword.isCorrect && updatePassword.password === updatePassword.confirmPassword) {
      dispatch(changeUserPassword({ user_id, password: updatePassword.password }))
      handleChangeOpen(!open)
    }
  }

  return (
    <StyledDialog
      open={open}
      onClose={() => handleChangeOpen(!open)}
      aria-labelledby="change-password-dialog"
      aria-describedby="change-password-dialog"
    >
      <DialogTitle id="form-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">{t('login.change-password')}</Typography>
          <Button onClick={() => handleChangeOpen(!open)} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
        <Grid container spacing={2}>
          <Grid xs={12}>
            <Box mb={0.5}>
              <Typography>{t('login.new-password')}</Typography>
            </Box>
            <StrongPassword
              password={updatePassword.password}
              property={'password'}
              handleInputChange={handleInputChange}
            />
          </Grid>
          <Grid xs={12}>
            <Box mb={0.5}>
              <Typography>{t('login.confirm-password')}</Typography>
            </Box>
            <StrongPassword
              password={updatePassword.confirmPassword}
              property={'confirmPassword'}
              handleInputChange={handleInputChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => handleChangeOpen(!open)}>{t('close')}</CancelButton>
        <SaveButton onClick={handleSubmit}>{t('save')}</SaveButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default UserChangePassword
